export class PersonalDataResponse {
  code!: string;
  message?: string;
  sections?: string[];
}
